import * as React from 'react';
import TruncateMarkup from 'react-truncate-markup';

import { useTranslations } from '~src/commons/utils/translations/translate';
import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';

interface MultilineEllipsisProps {
  lines?: number;
}

export const MultilineEllipsis: React.FC<React.PropsWithChildren<MultilineEllipsisProps>> = ({
  lines = 2,
  children,
}) => {
  const { tICU } = useTranslations();
  const [truncated, setTruncated] = React.useState(true);

  const handleToggle = () => {
    setTruncated(prev => !prev);
  };

  const toggleButton = (
    <button css={styles.button} onClick={handleToggle}>
      <span css={styles.dots}>... </span>
      <span css={styles.buttonText}>
        {tICU('widget.shipping_categories_folding.BUTTON.SHOW_MORE')}
      </span>
    </button>
  );

  return truncated ? (
    <TruncateMarkup lines={lines} ellipsis={toggleButton}>
      <span css={styles.ellipsis}>{children}</span>
    </TruncateMarkup>
  ) : (
    <span css={styles.ellipsis}>{children}</span>
  );
};

const styles = {
  ellipsis: {
    display: 'block',
    ...fontStyles.px12_16,
  },
  button: {
    outline: 'none',
    border: 'none',
    background: colors.white,
    color: colors.black,
    padding: 0,
  },
  dots: {
    color: colors.neutral35,
  },
  buttonText: {
    cursor: 'pointer',
  },
};
